import { render, staticRenderFns } from "./SaiAutoSuggest.vue?vue&type=template&id=9f3bd9cc&scoped=true"
import script from "./SaiAutoSuggest.vue?vue&type=script&lang=js"
export * from "./SaiAutoSuggest.vue?vue&type=script&lang=js"
import style0 from "./SaiAutoSuggest.vue?vue&type=style&index=0&id=9f3bd9cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3bd9cc",
  null
  
)

export default component.exports